import React, { useState } from 'react';
import { Dropdown } from 'antd';
import { ExpandMoreRounded } from '@mui/icons-material';
import Button from '@common/Button';

export const STATUS_CONFIG = {
    PLANNED:  { label: 'Planned',  dotColor: '#1677ff', color: '#0958d9', bgColor: '#e6f4ff' },
    ACTIVE:   { label: 'Active',   dotColor: '#fa8c16', color: '#d46b08', bgColor: '#fff7e6' },
    COMPLETE: { label: 'Complete', dotColor: '#52c41a', color: '#389e0d', bgColor: '#f6ffed' },
};

const MENU_ITEMS = Object.entries(STATUS_CONFIG).map(([key, { label }]) => ({ key, label }));

const LessonPlannerStatusButton = ({ status = 'PLANNED', onChange, placeholder, disabled = false }) => {
    const [open, setOpen] = useState(false);
    const config = STATUS_CONFIG[status] ?? STATUS_CONFIG.PLANNED;

    return (
        <Dropdown
            menu={{
                items: MENU_ITEMS,
                onClick: ({ key }) => onChange?.(key),
                selectedKeys: placeholder ? [] : [status],
            }}
            trigger={['click']}
            onOpenChange={setOpen}
            disabled={disabled}
        >
            {placeholder ? (
                <Button
                    type="outline"
                    className="ch-lesson-planner-status-btn"
                    icon={<ExpandMoreRounded className={`ch-lesson-planner-status-chevron${open ? ' ch-lesson-planner-status-chevron--open' : ''}`} />}
                    iconPosition="right"
                >
                    {placeholder}
                </Button>
            ) : (
                <Button
                    type="outline"
                    className="ch-lesson-planner-status-btn"
                    icon={<ExpandMoreRounded className={`ch-lesson-planner-status-chevron${open ? ' ch-lesson-planner-status-chevron--open' : ''}`} />}
                    iconPosition="right"
                    style={{
                        borderColor: config.color,
                        backgroundColor: config.bgColor,
                        color: config.color,
                    }}
                >
                    <span
                        className="ch-lesson-planner-status-dot"
                        style={{ backgroundColor: config.dotColor }}
                    />
                    {config.label}
                </Button>
            )}
        </Dropdown>
    );
};

export default LessonPlannerStatusButton;
